import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import ReactDOM from 'react-dom/client';
import { TourMain } from "./page/TourMain/TourMain";
import { TourLogin } from "./page/TourLogin/TourLogin";
import { TourRegister } from "./page/TourRegister/TourRegister";
import { ArtistRegister } from "./page/ArtistRegister/ArtistRegister";
import { StudioTour } from "./page/StudioTour/StudioTour";
import { StudioDetail } from "./page/StudioDetail/StudioDetail";
import { StudioPayment } from "./page/StudioPayment/StudioPayment";
import { CustomerMypage } from "./page/CustomerMypage/CustomerMypage";
import { ArtistMypage } from "./page/ArtistMypage/ArtistMypage";
import { ArtistStudio } from "./page/ArtistStudio/ArtistStudio";
import { StudioCreate } from "./page/StudioCreate/StudioCreate";
import { StudioEdit } from "./page/StudioEdit/StudioEdit";
import { YourNestAdmin } from "./page/YourNestAdmin/YourNestAdmin";
import { YourNestLogin } from "./page/YourNestLogin/YourNestLogin";
import { PaymentTransfer } from "./page/PaymentTransfer/PaymentTransfer";

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<TourMain />} />
        <Route path="/login" element={<TourLogin />} />
        <Route path="/register" element={<TourRegister />} />
        <Route path="/artist-register" element={<ArtistRegister />} />
        <Route path="/studio-tour" element={<StudioTour />} />
        <Route path="/studio-detail" element={<StudioDetail />} />
        <Route path="/studio-detail/:tourId" element={<StudioDetail />} />
        <Route path="/studio-payment" element={<StudioPayment />}>
          <Route path="success" element={<StudioPayment />} />
          <Route path="cancel" element={<StudioPayment />} />
          <Route path="fail" element={<StudioPayment />} />
        </Route>
        <Route path="/customer-mypage" element={<CustomerMypage />} />
        <Route path="/artist-mypage" element={<ArtistMypage />} />
        <Route path="/artist-studio" element={<ArtistStudio />} />
        <Route path="/artist-studio/create" element={<StudioCreate />} />
        <Route path="/artist-studio/edit/:tourId" element={<StudioEdit />} />
        <Route path="/admin" element={<YourNestAdmin />} />
        <Route path="/payment-transfer" element={<PaymentTransfer />} />

        <Route path="/yournest-admin" element={<YourNestAdmin />} />
        <Route path="/yournest-login" element={<YourNestLogin />} />
      </Routes>
    </BrowserRouter>
  );
};

const root = ReactDOM.createRoot(document.getElementById('app'));
root.render(<App/>);